export const CATCH_ERROR = "CATCH_ERROR";
export const SET_LOADER = "SET_LOADER";
export const RESET_ACTION = "RESET_ACTION";

export const CATCH_ERROR_APPS = "CATCH_ERROR_APPS";

export const FETCH_APPLICTION = "FETCH_APPLICTION";
export const DELETE_APPLICATION = "DELETE_APPLICATION";
export const GET_APPLICATION_DETAIL = "GET_APPLICATION_DETAIL";
export const RESET_APPLICATION = "RESET_APPLICATION";
export const UPDATE_APPLICATION = "UPDATE_APPLICATION";
export const OWNERS_LIST = "OWNERS_LIST";
export const ADD_OWNER = "ADD_OWNER";
export const REMOVE_OWNER = "REMOVE_OWNER";

export const FETCH_API_INSTANCE = "FETCH_API_INSTANCE";
export const APPLICATION_INSTANCE = "APPLICATION_INSTANCE";
export const GET_SLA_TIERS = "GET_SLA_TIERS";
export const CREATE_REQUEST = "CREATE_REQUEST";
export const CREATE_APPLICATION = "CREATE_APPLICATION";
export const REFETCH_APPLICATION = "REFETCH_APPLICATION";

export const FETCH_PENDING_REQUESTS = "FETCH_PENDING_REQUESTS";export const FETCH_ACCESS_REQUESTS = "FETCH_ACCESS_REQUESTS";
export const APPROVE_REQUEST = "APPROVE_REQUEST";
export const DENY_REQUEST = "DENY_REQUEST";
export const DELETE_REQUEST = "DELETE_REQUEST";